export const ADMIN_ACCESS = {
  admin: {
    defaultRoute: "/adminstration/menu",
    routes: [
      "/adminstration/menu",
      "/adminstration/materials",
      "/adminstration/tables",
      "/adminstration/invoices",
      "/adminstration/users",
      "/adminstration/clint",
      "/adminstration/clintgeneratedrink",
      "/adminstration/screens",
      "/auth/pos-pages",
      "/adminstration/conversations",
      "/adminstration/materialusage",
      "/adminstration/orderreports",
   
    ],
    menu: [
      { label: "المنيو", path: "/adminstration/menu" },
      { label: "الخامات", path: "/adminstration/materials" },
      { label: "الطاولات", path: "/adminstration/tables" },
      { label: "الفواتير", path: "/adminstration/invoices" },
      { label: "المستخدمين", path: "/adminstration/users" },
      { label: "العملاء", path: "/adminstration/clint" },
      { label: "مشروبات AI", path: "/adminstration/clintgeneratedrink" },
      { label: "الشاشات", path: "/adminstration/screens" },
      { label: "نقطة البيع", path: "/auth/pos-pages" },
      { label: "محادثات AI", path: "/adminstration/conversations" },
      { label: "استخدام المواد Ai", path: "/adminstration/materialusage" },
      { label: "تقارير الطلبات", path: "/adminstration/orderreports" },
    ],
  },

    head_manager: {
  defaultRoute: "/adminstration/menu",
    routes: [
      "/adminstration/menu",
      "/adminstration/materials",
      "/adminstration/tables",
      "/adminstration/invoices",
      "/adminstration/users",
      "/adminstration/clint",
      "/adminstration/clintgeneratedrink",
      "/adminstration/screens",
      "/auth/pos-pages",
      "/adminstration/conversations",
      "/adminstration/materialusage",
      "/adminstration/orderreports",
    ],
    menu: [
      { label: "المنيو", path: "/adminstration/menu" },
      { label: "الخامات", path: "/adminstration/materials" },
      { label: "الطاولات", path: "/adminstration/tables" },
      { label: "الفواتير", path: "/adminstration/invoices" },
      { label: "المستخدمين", path: "/adminstration/users" },
      { label: "العملاء", path: "/adminstration/clint" },
      { label: "مشروبات AI", path: "/adminstration/clintgeneratedrink" },
      { label: "الشاشات", path: "/adminstration/screens" },
      { label: "نقطة البيع", path: "/auth/pos-pages" },
      { label: "استخدام المواد Ai", path: "/adminstration/materialusage" },
      { label: "محادثات AI", path: "/adminstration/conversations" },
    ],
  },
  
    manager: {
    defaultRoute: "/adminstration/menu",
    routes: [
      "/adminstration/menu",
      "/adminstration/materials",
      "/adminstration/invoices",
      "/adminstration/clint",
      "/adminstration/clintgeneratedrink",
      "/adminstration/screens",
      "/auth/pos-pages",
      "/adminstration/orderreports",
    ],
    menu: [
      { label: "المنيو", path: "/adminstration/menu" },
      { label: "الخامات", path: "/adminstration/materials" },
      { label: "الفواتير", path: "/adminstration/invoices" },
      { label: "العملاء", path: "/adminstration/clint" },
      { label: "مشروبات AI", path: "/adminstration/clintgeneratedrink" },
      { label: "الشاشات", path: "/adminstration/screens" },
      { label: "نقطة البيع", path: "/auth/pos-pages" },
      { label: "تقارير الطلبات", path: "/adminstration/orderreports" },
    ],
  },

  user: {
    defaultRoute: "/adminstration/invoices",
    routes: ["/adminstration/invoices",
      "/adminstration/materialusage",
      "/adminstration/materials",
            "/adminstration/materialusage",
      "/adminstration/orderreports",
    ],
    menu: [{ label: "الفواتير", path: "/adminstration/invoices" },
    { label: "استخدام المواد Ai", path: "/adminstration/materialusage" },
    { label: "الخامات", path: "/adminstration/materials" },
    { label: "استخدام المواد Ai", path: "/adminstration/materialusage" },
    { label: "تقارير الطلبات", path: "/adminstration/orderreports" },

    ],
  },
    cashier: {
    defaultRoute: "/auth/pos-pages",
    routes: ["/auth/pos-pages"],
    menu: [{ label: "نقطة البيع", path: "/auth/pos-pages" }],
  },

  kitchen: {
    defaultRoute: "/admin/kit",
    routes: ["/admin/kit"],
    menu: [{ label: "المطبخ", path: "/admin/kit" }],
  },

};

export const getAdminRoleAccess = (role) => {
  return ADMIN_ACCESS?.[role] || null;
};
